import { ProjectIssuanceConstants } from "../../../constants";

export const isUnitKmHabitatType = (habitatType: string | null): boolean =>
  ProjectIssuanceConstants.BNG_UNITKM_HABITAT_TYPES.some((x) => x === habitatType);
